import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import { CachedApi } from './CachedApi'

export class MetaApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
	}

	get (url) {

		let c = new CachedApi();

		if (!url) {
			return c.get(this.url + '/metadata')
		}
		return c.get(this.url + '/metadata/' + url)
	}
}
